import { Accept } from 'react-dropzone';

interface FormsConfig {
  commonAcceptedFiles: Accept;
}

export const formsConfig: FormsConfig = {
  /**
   * If you want to take a look of how to
   * add new types, click the link below:
   * https://react-dropzone.org/#!/Accepting%20specific%20file%20types
   */
  commonAcceptedFiles: {
    'application/pdf': ['.pdf'],
    'image/*': ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'application/vnd.ms-powerpoint': ['.ppt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
    'text/csv': ['.csv'],
  },
};
